<div class="header-betslip">
  <div (click)="removeAllBets()" class="header-action-del-all">Remove All bets</div>
  <div class="header-title">Bet Slip</div>
  <div class="header-close">
    <fa-icon (click)="onCloseBetslip()" [icon]="faTimes" size="1x"></fa-icon>
  </div>
</div>
